import {all, fork} from 'redux-saga/effects';
import scanningHistoryWatcher from './ScanningHistory/sagaWatcher';

export default function*() {
    yield all([
        fork(scanningHistoryWatcher),
    ]);
}
